/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

// NavButton.js
import React from 'react';
import './NavButton.css';

export default function NavButton({ label, position, icon, onClick }) {
  return (
    <button className={`nav-button ${position}`} onClick={onClick}>
      {icon && <span className="icon">{icon}</span>}
      {label}
    </button>
  );
}

